<template>
    <form @submit.prevent="handleSubmit" autocomplete="off">
        <div class="form-group">
            <label for="name" class="col-form-label">Nombre</label>
            <input
                class="form-control"
                id="name"
                type="text"
                :class="{ 'is-invalid' : errors.name }"
                v-model="form.name"
            >
            <invalid-feedback :error="errors.name"></invalid-feedback>
        </div>
        <div class="form-group">
            <label for="url_admin" class="col-form-label">URL Administración</label>
            <input
                class="form-control"
                id="url_admin"
                type="url"
                :class="{ 'is-invalid' : errors.url_admin }"
                v-model="form.url_admin"
            >
            <invalid-feedback :error="errors.url_admin"></invalid-feedback>
        </div>
        <div class="form-group">
            <label for="url_home" class="col-form-label">URL Sitio principal</label>
            <input
                aria-describedby="url-home-help"
                class="form-control"
                id="url_home"
                type="url"
                :class="{ 'is-invalid' : errors.url_home }"
                v-model="form.url_home"
            >
            <small id="url-home-help" class="form-text text-muted">Puede quedar vacío.</small>
            <invalid-feedback :error="errors.url_home"></invalid-feedback>
        </div>
        <div class="form-group" v-show="emails.includes(email)">
            <label for="git_branch" class="col-form-label">GIT Branch (para deploy)</label>
            <input
                aria-describedby="url-git-branch-help"
                class="form-control"
                id="git_branch"
                type="text"
                :class="{ 'is-invalid' : errors.git_branch }"
                v-model="form.git_branch"
            >
            <small id="url-git-branch-help" class="form-text text-muted">Branch para ejecutar deploy. Puede quedar vacío.</small>
            <invalid-feedback :error="errors.git_branch"></invalid-feedback>
        </div>
        <div class="form-group">
            <label for="logo" class="col-form-label">Logo</label>
            <input
                accept="image/*"
                class="form-control"
                id="logo"
                type="file"
                :class="{ 'is-invalid' : errors.logo }"
                @change="handleImage($event)"
                ref="logo"
            >
            <invalid-feedback :error="errors.logo"></invalid-feedback>
        </div>
        <button type="submit" class="btn btn-primary btn-block">Guardar</button>
    </form>
</template>

<script>
    import InvalidFeedback from '@/components/InvalidFeedback'

    export default {
        props: {
            emails: Array,
            email: String
        },
        data() {
            return {
                errors: [],
                form: {
                    name: '',
                    git_branch: '',
                    url_admin: '',
                    url_home: ''
                },
                logo: ''
            }
        },
        methods: {
            handleImage(evt) {
                this.logo = _.head(evt.target.files)
            },
            handleSubmit() {
                const formData = new FormData()
                formData.append('git_branch', this.form.git_branch)
                formData.append('logo', this.logo)
                formData.append('name', this.form.name)
                formData.append('url_admin', this.form.url_admin)
                formData.append('url_home', this.form.url_home)

                axios.post(this.route('admin.clients.store'), formData)
                .then(response => {
                    this.$refs.logo.value = null
                    window.location.href = this.route('home')
                }).catch(error => {
                    const { status } = error.response
                    if (status === 422) {
                        this.errors = error.response.data.errors
                    }
                })
            }
        },
        components: {
            'invalid-feedback': InvalidFeedback
        }
    }
</script>